import { CesFreeTextQuestionComponent } from './ces-free-text-question/ces-free-text-question.component';
import { CesRatingQuestionComponent } from './ces-rating-question/ces-rating-question.component';

export const QUESTION_TYPES_MAPPING: { [questionType: string]: any } = {
  rating: CesRatingQuestionComponent,
  freeText: CesFreeTextQuestionComponent,
};
